import { render, staticRenderFns } from "./QuestionFileMetadataEditor.vue?vue&type=template&id=f8032796&scoped=true"
import script from "./QuestionFileMetadataEditor.vue?vue&type=script&lang=js"
export * from "./QuestionFileMetadataEditor.vue?vue&type=script&lang=js"
import style0 from "./QuestionFileMetadataEditor.vue?vue&type=style&index=0&id=f8032796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8032796",
  null
  
)

export default component.exports